import React from "react";
import FormField from "../../../common/FormField/FormField";
import { Formik } from "formik";
import { CustomFileUpload } from "../../../common/FormInputs";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { navigate } from "@reach/router";
import { splitPdfValidationSchema } from "../../../../helpers/validationSchema";
import { StyledForm, ButtonGroup, BackButton, SubmitButton } from "./styles";
import AWSService from "../../../../services/AWSService";
import { getErrorMessage, getFileName } from "../../../../helpers/functions";
import axios from "axios";
import { Card, FormGrid, Label, PageWrapper, Section } from "./SplitAndUpload";

const SplitPdf = () => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  async function s3Upload(file, field, setFieldValue, setFieldError) {
    if (file) {
      try {
        const errorMessage = "Invalid File Type";
        if (file?.type !== "application/pdf") throw errorMessage;
        setLoader({ state: true, message: `Uploading file ${file.name} ...` });
        const payload = {
          key: file.name,
        };
        const s3Response = await AWSService.getS3URL(payload);
        if (s3Response.url) {
          const res = await AWSService.uploadToS3(s3Response.url, file);
          setFieldValue(field, res);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
  }

  const inputs = [
    {
      name: "startText",
      type: "text",
      label: "Start Text",
      required: true,
    },
    {
      name: "endText",
      type: "text",
      label: "End Text",
      required: false,
    },
  ];

  const upload_inputs = [
    {
      name: "pdfFile",
      label: "Pdf File",
      type: "upload",
      required: true,
      accept: ".pdf",
    },
  ];

  async function onFormSubmit(values, { resetForm }) {
    setLoader({ state: true, message: "please wait..." });
    const headers = {
      "content-type": "application/json",
    };
    const payload = {
      startText: values?.startText,
      endText: values?.endText,
      pdfFile: values?.pdfFile,
    };
    axios
      .post(`https://mod.justact.co.in/split-pdf`, payload, {
        headers,
      })
      .then((response) => {
        if (response.statusText) {
          const a = document.createElement("a");
          a.href = response?.data?.outputZipFile;
          a.download = `${getFileName(response?.data?.outputZipFile)}`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          resetForm();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader({ state: false });
        resetForm(false);
      });
  }

  return (
    <PageWrapper>
      <Card>
        <Formik
          initialValues={{
            startText: "",
            endText: "",
            pdfFile: "",
          }}
          validationSchema={splitPdfValidationSchema}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            handleChange,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldError,
            resetForm,
          }) => (
            <StyledForm>
              <Section>
                <FormGrid>
                  {inputs.map((input, index) => (
                    <FormField
                      key={index}
                      {...{
                        input,
                        values,
                        handleBlur,
                        handleChange,
                        touched,
                        errors,
                      }}
                    />
                  ))}
                  {upload_inputs.map((upload, index) => (
                    <div>
                      <Label>
                        {upload.label} <span className="required-star"> *</span>
                      </Label>
                      <CustomFileUpload
                        error={touched[upload.name] && errors[upload.name]}
                        setFile={(file) =>
                          s3Upload(
                            file,
                            upload.name,
                            setFieldValue,
                            setFieldError,
                          )
                        }
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                        accept={upload.accept}
                        file={{
                          name: getFileName(values[upload.name]),
                        }}
                      />
                    </div>
                  ))}
                </FormGrid>
              </Section>
              <ButtonGroup>
                <BackButton onClick={() => navigate("/dashboard/case-manager")}>
                  Back
                </BackButton>
                <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
              </ButtonGroup>
            </StyledForm>
          )}
        </Formik>
      </Card>
    </PageWrapper>
  );
};

export default SplitPdf;
